import { ReactComponent as InfoSvg } from './Info.svg';

const icons = {
  info: <InfoSvg className='status-icon' />,
};

export default icons;
